import { Routes } from '@angular/router';

import { ClubsPage } from './clubs.page';
import { clubMembersRoutes } from './club-members/club-members.routes';
import { clubAddRoutes } from './club-add/club-add.routes';

export const clubsRoutes: Routes = [
  {
    path: '',
    component: ClubsPage,
  },
  {
    path: 'club-members',
    children: clubMembersRoutes,
  },
  {
    path: 'club-add',
    children: clubAddRoutes,
  },
];
